// extracted by mini-css-extract-plugin
module.exports = {"FavIconStyles":"FavIcon_FavIconStyles__2160t"};